import React from 'react';
import {
  Stack,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
} from '@mui/material';

export type AchAccountType = 'checking' | 'savings';

type AchBankFieldsProps = {
  routingNumber: string;
  accountNumber: string;
  accountType: AchAccountType;
  onRoutingNumber: (value: string) => void;
  onAccountNumber: (value: string) => void;
  onAccountType: (value: AchAccountType) => void;
  disabled?: boolean;
};

export const achBankReady = (
  routingNumber: string,
  accountNumber: string,
  accountType: string
): boolean =>
  /^\d{9}$/.test(routingNumber.trim()) &&
  /^\d{4,17}$/.test(accountNumber.trim()) &&
  (accountType === 'checking' || accountType === 'savings');

const AchBankFields: React.FC<AchBankFieldsProps> = ({
  routingNumber,
  accountNumber,
  accountType,
  onRoutingNumber,
  onAccountNumber,
  onAccountType,
  disabled,
}) => (
  <Stack spacing={2}>
    <TextField
      label="Routing number"
      size="small"
      fullWidth
      value={routingNumber}
      disabled={disabled}
      onChange={(e) => onRoutingNumber(e.target.value)}
      inputProps={{ inputMode: 'numeric', autoComplete: 'off', maxLength: 9 }}
    />
    <TextField
      label="Account number"
      size="small"
      fullWidth
      value={accountNumber}
      disabled={disabled}
      onChange={(e) => onAccountNumber(e.target.value)}
      inputProps={{ inputMode: 'numeric', autoComplete: 'off', maxLength: 17 }}
    />
    <ToggleButtonGroup
      exclusive
      size="small"
      value={accountType}
      disabled={disabled}
      onChange={(_, value) => value && onAccountType(value)}
    >
      <ToggleButton value="checking">Checking</ToggleButton>
      <ToggleButton value="savings">Savings</ToggleButton>
    </ToggleButtonGroup>
  </Stack>
);

export default AchBankFields;
